import React from 'react';
import { motion } from 'framer-motion';
import { Search, Send, Handshake, Lock, CheckCircle } from 'lucide-react';
const steps = [{
  icon: <Search className="w-5 h-5" data-id="element-535" />,
  title: 'Discover the right match'
}, {
  icon: <Send className="w-5 h-5" data-id="element-536" />,
  title: 'Reach out or get discovered'
}, {
  icon: <Handshake className="w-5 h-5" data-id="element-537" />,
  title: 'Negotiate inside your rules'
}, {
  icon: <Lock className="w-5 h-5" data-id="element-538" />,
  title: 'Lock contracts, deposits, and lineup'
}, {
  icon: <CheckCircle className="w-5 h-5" data-id="element-539" />,
  title: 'Advance the show and track settlement'
}];
export function WorkflowSection() {
  return <section className="py-24 overflow-hidden" data-id="element-540">
      <div className="max-w-7xl mx-auto px-6" data-id="element-541">
        <div className="text-center mb-20" data-id="element-542">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold" data-id="element-543">
            How Booker works
          </motion.h2>
        </div>

        <div className="relative" data-id="element-544">
          {/* Animated Connecting Line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-px -translate-y-1/2 z-0" data-id="element-545">
            <svg className="w-full h-full" preserveAspectRatio="none" data-id="element-546">
              <line x1="0" y1="0" x2="100%" y2="0" stroke="#27272A" strokeWidth="2" data-id="element-547" />
              <motion.line x1="0" y1="0" x2="100%" y2="0" stroke="#F59E0B" strokeWidth="2" initial={{
              strokeDasharray: '1000',
              strokeDashoffset: '1000'
            }} whileInView={{
              strokeDashoffset: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 2,
              ease: 'easeInOut'
            }} data-id="element-548" />
            </svg>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 relative z-10" data-id="element-549">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            delay: index * 0.4
          }} // Stagger matches line drawing
          className="flex flex-col items-center text-center group" data-id="element-550">
                <div className="relative" data-id="element-551">
                  {/* Subtle glow behind active step */}
                  <motion.div initial={{
                opacity: 0,
                scale: 0.5
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true,
                margin: '-100px'
              }} transition={{
                delay: index * 0.4 + 0.2
              }} className="absolute inset-0 bg-primary/20 rounded-full blur-md" data-id="element-552" />

                  <motion.div whileInView={{
                borderColor: ['#27272A', '#F59E0B', '#27272A'],
                color: ['#A1A1AA', '#F59E0B', '#F5F5F5']
              }} viewport={{
                once: true,
                margin: '-100px'
              }} transition={{
                delay: index * 0.4,
                duration: 1
              }} className="w-14 h-14 rounded-full bg-surface border-2 border-border flex items-center justify-center mb-6 text-textMuted relative z-10 group-hover:border-primary group-hover:text-primary transition-colors group-hover:shadow-[0_0_15px_rgba(245,158,11,0.4)]" data-id="element-553">
                    {step.icon}
                  </motion.div>
                </div>
                <h4 className="text-sm font-semibold text-textMain group-hover:text-primary transition-colors" data-id="element-554">
                  {step.title}
                </h4>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}